import { clearSessionKeys, getSession, setErrorReportingData, setSession } from '../../services/session';
import useQueryString from './useQueryString';
import useSSR from './useSSR';

export const SOURCE_GA = 'ga-novacoop';
export const SOURCE_4BEE = '4bee';

const URL_PARAM_KEY_APDATA = 'APDATAPARAMS';
const URL_PARAM_KEY_4BEE = '4BEEPARAMS';

const sourceSystemMap = {
  [URL_PARAM_KEY_APDATA]: SOURCE_GA,
  [URL_PARAM_KEY_4BEE]: SOURCE_4BEE,
};

const getCredentials = (key) => {
  const credentials = getSession(key);
  if (credentials) {
    const credentialsAsJson = JSON.parse(credentials);
    setErrorReportingData(key, credentialsAsJson.token);
    return credentialsAsJson;
  }
  return null;
};

const saveCredentials = (sourceSystemKey, searchParams) => {
  const token = searchParams[sourceSystemKey].valueOf();
  const availableTenants = ['nova_coop', 'execnet', 'conexao_saude'];
  const employeeCredentials = {
    ...searchParams,
    token,
    sourceSystem: sourceSystemMap[sourceSystemKey],
    tenant: availableTenants.includes(searchParams.tenant) ? searchParams.tenant : undefined,
  };

  /**
   * Limpa todas as credenciais, exceto a atual, para não trazer sessões antigas na busca por sessão
   * Evita buscar a sessão errada quando o usuário acessa o sistema pelo 4bee e apdata no mesmo PC
   */
  const keys = Object.keys(sourceSystemMap).filter((key) => key !== sourceSystemKey);
  clearSessionKeys(keys);

  /**
   * Foi uma solicitação da infra ocultar os parâmetros da URL para que os
   * usuários não compartilhem o link com o token. Então a solução foi salvar na sessão
   * o token para os casos em que o usuário atualiza a página e está sem o token na URL.
   */
  setSession(sourceSystemKey, JSON.stringify(employeeCredentials));
  setErrorReportingData(sourceSystemKey, token);

  return employeeCredentials;
};

/**
 * Get employee credentials from 4bee or apdata
 * @returns {{sourceSystem: string, token: (string|string)}|undefined}
 */
export default function useEmployeeCredentials() {
  const searchParams = useQueryString();
  if (!useSSR()) {
    const keys = Object.keys(sourceSystemMap);

    // Primeiro tenta obter as credenciais via params da URL
    // eslint-disable-next-line no-restricted-syntax
    for (const sourceSystemKey of keys) {
      if (searchParams[sourceSystemKey]) {
        return saveCredentials(sourceSystemKey, searchParams);
      }
    }

    // Caso não exista credenciais nos params da URL, tenta buscar da sessão
    // eslint-disable-next-line no-restricted-syntax
    for (const sourceSystemKey of keys) {
      const credentials = getCredentials(sourceSystemKey);
      if (credentials) {
        return credentials;
      }
    }
  }

  return {};
}
